<div class="calendar-container scr-page scr-page--wide">
  <div class="board scr-card">
  <!-- Dense working screen: title, month and week navigation live in the board toolbar (no page header). -->
  <div class="board-toolbar">
    <div class="board-toolbar__title">
      <h1>Órdenes de montaje</h1>
      <span class="board-toolbar__month">{{ monthTitle }}</span>
    </div>
    <div class="week-nav">
      <button
        type="button"
        class="navigation-button"
        (click)="navigateWeek(-1)"
        title="Semana anterior"
        aria-label="Semana anterior"
        >
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button
        type="button"
        class="navigation-button"
        (click)="navigateWeek(1)"
        title="Semana siguiente"
        aria-label="Semana siguiente"
        >
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>

  <div
    class="scrollable"
    (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd()"
    >
    @for (day of dayList; track day; let i = $index) {
      <div
        class="day-col"
        [ngClass]="{
          'col-hidden': i >= visibleColumns,
          'col-collapsed': i >= visibleColumns && visibleColumns >= 6 && !loading && day.orders.length === 0
        }"
        [style.flex-basis]="getDynamicWidth(i)"
        >
        <div class="column-header col-12">
          <strong>{{ day.description }}</strong>
          @if (!loading && day.orders.length > 0) {
            <span class="column-header__count">{{ day.orders.length }}</span>
          }
        </div>
        @if (loading && day.orders.length === 0) {
          <div class="ao-skeleton" aria-hidden="true">
            <span></span><span></span><span></span>
          </div>
        }
        @if (!loading && day.orders.length === 0) {
          <p class="day-empty">Sin órdenes</p>
        }
        @for (order of day.orders; track trackById($index, order)) {
          <app-manufacturing-order
            #orderComp
            class="assemblyOrderContainer m-0 p-0"
        [ngClass]="{
          'two-per-row':
            visibleColumns < 3 &&
            currentScreenWidth &&
            currentScreenWidth > 768 &&
            day.orders.length > 1,
          'three-per-row':
            visibleColumns === 1 &&
            currentScreenWidth &&
            currentScreenWidth > 768 &&
            day.orders.length > 2,
          selected: order.id === orderToPointId
        }"
            [style.pointer-events]="preventInteraction(order) ? '' : 'none'"
            [assemblyOrder]="order"
            [maxHeight]="maxHeight"
            [showOrderDetails]="showOrderDetails"
            (click)="openOrderDetail(order)"
            >
          </app-manufacturing-order>
        }
      </div>
    }
  </div>

  </div>

  <div
    class="order-details-container d-flex align-items-center justify-content-center w-100"
    [ngClass]="{ expanded: showOrderDetails }"
    >
    @if (showOrderDetails) {
      <button type="button" class="backButton" (click)="backToCalendar()" data-tp-back>
        <mat-icon aria-hidden="true">arrow_back</mat-icon>
        <span>Volver al calendario</span>
      </button>
    }
    @if (selectedAssemblyOrder != null && showOrderDetails) {
      <div
        class="details-container w-100"
        >
        <manufacturing-order-details
          [assemblyOrder]="selectedAssemblyOrder!"
          (statusChangedResult)="notifyChanges($event)"
        ></manufacturing-order-details>
      </div>
    }
  </div>
</div>
